<template>
  <div>
    <v-data-table
      class="spider-table"
      :value="value"
      :headers="headers"
      :items="items"
      :disable-pagination="true"
      :loading="loading"
      :item-class="getRowClass"
      :server-items-length="itemsCount"
      :sort-by.sync="sortColumn"
      :sort-desc.sync="sortDescending"
      :must-sort="true"
      :footer-props="{
        disablePagination: true,
        pageText: '',
        nextIcon: '',
        prevIcon: '',
        itemsPerPageOptions: [20, 50, 100],
      }"
      :single-select="loading"
      item-key="id"
      dense
      show-select
      @click:row="onItemClick"
      @contextmenu:row="onContextMenuClick"
      @input="$emit('input', $event)"
      @update:sort-by="onSortChange"
      @update:sort-desc="onSortChange"
      @update:items-per-page="onPageSizeChange"
    >
      <template v-slot:header.pages>
        <v-icon title="Последний обход">assignment_turned_in</v-icon>
      </template>
      <template v-slot:header.analyze>
        <v-icon title="Анализ">analytics</v-icon>
      </template>
      <template v-slot:item.health="{ item }">
        <v-tooltip v-if="isHealthIconVisible(item)" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon :color="getStateColor(item)" v-bind="attrs" v-on="on">local_hospital</v-icon>
          </template>
          <span> Уровень здоровья {{ item.health }}% </span>
        </v-tooltip>
      </template>
      <template v-slot:item.note="{ item }">
        <div class="d-flex">
          <v-tooltip v-if="item.note" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="orange--text text--darken-2" v-bind="attrs" v-on="on">
                speaker_notes
              </v-icon>
            </template>
            <span class="spider_table__tooltip">
              {{ item.note }}
            </span>
          </v-tooltip>
          <v-icon v-if="item.plugin_id" title="Подключаемый парсер">cable</v-icon>
          <v-icon v-if="item.additional" title="Дополнительный парсер">content_copy</v-icon>
        </div>
      </template>
      <template v-slot:item.status_changed="{ item }">
        {{ $moment(item.status_changed).format() }}
      </template>
      <template v-slot:item.modified="{ item }">
        {{ $moment(item.modified).format() }}
      </template>
      <template v-slot:item.last_result_publish_date="{ item }">
        {{ item.last_result_publish_date && $moment(item.last_result_publish_date).format() }}
      </template>
      <template v-slot:item.pages="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <span>{{ item.last_valid_pages || 0 }}</span>
              <span>/</span>
              <span>{{ item.last_total_pages || 0 }}</span>
            </div>
          </template>
          <span class="spider_table__tooltip">
            Собрано: {{ item.last_valid_pages || 0 }} <br />
            Посещено: {{ item.last_total_pages || 0 }} <br />
          </span>
        </v-tooltip>
      </template>
      <template v-slot:item.analyze="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <span>{{ item.analyze_samples || 0 }}</span>
              <span>/</span>
              <span>{{ item.analyze_results || 0 }}</span>
              <span>/</span>
              <span>{{ item.analyze_hits || 0 }}</span>
            </div>
          </template>
          <span class="spider_table__tooltip">
            {{ $moment(item.analyze_date).format() }} <br />
            В эталоне: {{ item.analyze_samples || 0 }} <br />
            В результатах: {{ item.analyze_results || 0 }} <br />
            Совпадений: {{ item.analyze_hits || 0 }} <br />
          </span>
        </v-tooltip>
        <div :title="$moment(item.analyze_date).format()"></div>
      </template>
      <template v-slot:top>
        <div class="d-flex justify-space-between">
          <div class="py-2 pl-4">
            <v-icon title="Выделить между отмеченными" @click="onSelectBetweenClick">
              checklist
            </v-icon>
          </div>
          <v-pagination
            :value="page"
            :length="pageCount"
            :total-visible="10"
            @input="onPageChange"
          ></v-pagination>
          <div></div>
        </div>
        <slot name="header"></slot>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Vue from 'vue'
import { isUserSelectingText } from '@/core/selection'

export default Vue.extend({
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemsCount: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    pageCount: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    highlight: {
      type: String,
      default: () => null,
    },
  },
  data: () => ({
    highlightClass: 'blue lighten-5',
    clusteredClass: 'green lighten-4',
    sortColumn: '',
    sortDescending: false,
    healthIconVisibleFor: [
      'TESTING',
      'ACTIVE',
      'ACTIVE_7',
      'ACTIVE_30',
      'ACTIVE_90',
      'ACTIVE_PARTIAL',
    ],
    headers: [
      {
        value: 'health',
        width: '40px',
      },
      {
        value: 'note',
        sortable: false,
        width: '40px',
      },
      {
        align: 'center',
        value: 'pages',
        sortable: true,
        width: '80px',
      },
      {
        align: 'center',
        value: 'analyze',
        sortable: false,
        width: '40px',
      },
      {
        text: 'Источник',
        align: 'start',
        value: 'source.name',
      },
      {
        text: 'Статус',
        value: 'status_name',
        width: '120px',
      },
      {
        text: 'Посл. ст.',
        value: 'prev_status_name',
        width: '120px',
      },
      {
        text: 'Изменение статуса',
        value: 'status_changed',
        width: '120px',
      },
      {
        text: 'Изменение настроек',
        value: 'modified',
        width: '120px',
      },
      {
        text: 'Свежая новость',
        value: 'last_result_publish_date',
        width: '120px',
      },
      {
        text: 'Изменил',
        align: 'start',
        value: 'username',
        width: '120px',
      },
    ],
  }),
  methods: {
    onItemClick(value) {
      if (!isUserSelectingText()) {
        this.$emit('click', value)
      }
    },
    getRowClass(item) {
      if (this.highlight != null && this.highlight == item.id) {
        return this.highlightClass
      }
      if (item.clustered) {
        return this.clusteredClass
      }
    },
    onPageChange(page) {
      this.$emit('update:page', page)
    },
    onPageSizeChange(pageSize) {
      this.$emit('update:page-size', pageSize)
    },
    onSortChange() {
      if (!this.sortColumn) {
        this.$emit('update:sort', null)
      }
      this.$emit('update:sort', this.sortDescending ? '-' + this.sortColumn : this.sortColumn)
    },
    onContextMenuClick(mouseEvent, dataEvent) {
      this.$emit('contextmenu:row', mouseEvent, dataEvent)
    },
    getStateColor(item) {
      if (item == null || item.state == null) {
        return ''
      }
      if (item.state === 'OK') {
        return 'success'
      }
      if (item.state === 'PROBLEM') {
        return 'warning'
      }
      if (item.state == 'DEAD') {
        return 'error'
      }
    },
    isHealthIconVisible(item) {
      return this.healthIconVisibleFor.includes(item.status)
    },
    onSelectBetweenClick() {
      let minIndex = null
      let maxIndex = null
      this.items.forEach((item, idx) => {
        if (!this.value.includes(item)) {
          return
        }

        minIndex = minIndex == null ? idx : Math.min(idx, minIndex)
        maxIndex = maxIndex == null ? idx : Math.max(idx, maxIndex)
      })

      if (minIndex == null || maxIndex == null) {
        return
      }

      this.items.slice(minIndex, maxIndex).forEach(item => {
        if (this.value.includes(item)) {
          return
        }

        this.value.push(item)
      })
    },
  },
})
</script>
<style lang="scss" scoped>
.spider-table {
  ::v-deep tr {
    cursor: pointer;
  }
}
.spider_table__tooltip {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
}
</style>
